<template>
    <div id="book-container" ref="bookContainer" :style="bookContainerStyle">
        <div id="svg-clip-path">
            <div id="svg-scaler" ref="svg_scaler">
                <div id="svg-container" ref="svg_container">
                    <img id="left-page-loading" />
                    <img id="right-page-loading" />
                    <div id="left-page-svg" class="page-svg" :class="svgOpacity" type="image/svg+xml" contenteditable="true"></div>
                    <div id="right-page-svg" class="page-svg" :class="svgOpacity" type="image/svg+xml" contenteditable="true"></div>
                </div>
            </div>
            <div id="full-png-page" :class="svgOpacity"></div>
            <div id="svg-text-scaler" ref="svg_text_scaler">
                <div id="svg-text-container" ref="svg_text_container">
                    <div id="left-page-svg-text" class="page-svg" :class="svgOpacity" type="image/svg+xml" contenteditable="true"></div>
                    <div id="right-page-svg-text" class="page-svg" :class="svgOpacity" type="image/svg+xml" contenteditable="true"></div>
                </div>
            </div>
        </div>
        <div
            id="page-container"
            ref="page_container"
            @mousewheel="wheelHandler"
            @pointerdown="onPointerDown"
            @pointerup="onPointerUp"
            @pointermove="onPointerMove"
            :class="pageOpacity"
        >
            <div id="left-page" class="page">
                <div
                    id="animation_container"
                    ref="animation_container"
                    style="
                        background-color: rgba(255, 255, 255, 0);
                        width: 1920px;
                        height: 2160px;
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        pointer-events: none;
                    "
                >
                    <canvas id="canvas" width="1920" height="2160" style="position: absolute; display: none; background-color: rgba(255, 255, 255, 0)"></canvas>
                    <div
                        id="dom_overlay_container"
                        style="pointer-events: none; overflow: hidden; width: 1920px; height: 2160px; position: absolute; left: 0px; top: 0px; display: none"
                    ></div>
                </div>
                <div id="preload_div_" style="position: absolute; top: 0; left: 0; display: inline-block; height: 2160px; width: 3840px; text-align: center">
                    <span style="display: inline-block; height: 100%; vertical-align: middle"></span>
                    <img src="../assets/_preloader.gif" style="vertical-align: middle; max-height: 100%" />
                </div>
                <canvas
                    ref="paintCanvas"
                    id="paint-canvas"
                    :width="canvasWidth"
                    :height="canvasHeight"
                    style="position: absolute; left: 0px; top: 0px; background-color: rgba(255, 255, 255, 0)"
                ></canvas>
            </div>
        </div>
    </div>
    <div
        class="zoom-part-zone"
        ref="zoomPartZone"
        :style="{
            left: zoomLeft + 'px',
            top: zoomTop + 'px',
            width: zoomWidth + 'px',
            height: zoomHeight + 'px',
            transformOrigin: 'left top',
            transform: 'rotateX(' + rotateX + 'deg) ' + 'rotateY(' + rotateY + 'deg) ',
        }"
    ></div>
    <div v-show="store.editingToolBar" class="deleteZone" @mouseover="handleDeleteZone"></div>
    <div class="tools" :style="toolStyle">
        <Ruler ref="ruler" :tool-scale="containerScale"></Ruler>
    </div>
    <OnlyReadButtons ref="onlyReadButtons"></OnlyReadButtons>
</template>

<script>
import PageLoader from "../js/page_loader";
import PageItemCreator from "../js/pageItem_control";
import PageControl from "../js/page_control";
import PainterProxy from "../js/painter/proxy";
import { store } from "../store";
import { TOOLS } from "../js/toolbar/tools";
import { focusStore } from "../js/store/nowFocusStore";
import { settingStore } from "../js/store/settingStore";
import PageMove from "../js/book_page/page_move";
import TouchMove from "../js/book_page/touch_move";
import ZoomPart from "../js/book_page/zoom_part";
import TouchScale from "../js/book_page/touch_scale";
import EventBus from "../js/event_bus";
import { TURN_PAGE_TYPE } from "../js/book_define/turn_page_type";
import { windowContentScaleX, windowContentScaleY } from "../js/common/content_scale";
import { bookPageStore } from "../js/store/bookPageStore";
import Ruler from "../components/math_tool/ruler.vue";
import OnlyReadButtons from "./UI/OnlyReadButtons.vue";

export default {
    name: "BookPage",
    data: function () {
        return {
            containerSize: {
                width: 0,
                height: 0,
            },
            containerScale: 1,
            containerPosition: { x: 0, y: 0 },
            pageContainer: null,
            bookContainer: null,
            pageLoader: null,
            isLoading: false,
            svgContainer: null,
            svgTextContainer: null,
            moveDelta: { x: 0, y: 0 },
            fixedScaleMargin: 0,
            fixedScaleMarginRight: 0,
            canvasWidth: 0,
            canvasHeight: 0,
            startMove: false,

            zoomLeft: 0,
            zoomTop: 0,
            zoomWidth: 0,
            zoomHeight: 0,
            rotateX: 0,
            rotateY: 0,

            loadingOpacity: 1,
            interval: null,

            settingStore,
            store,

            currentPageTool: undefined,
            /**
             * @type Map<string, PageToolBase>
             */
            pageToolMap: new Map(),

            pagePercentPoint: {},

            scaleRatio: 0.2,
            pageContainerShow: false,
            svgShow: false,
            touchPointList: [],
            isPressBookPage: false,

            svgScalerOffsetX: 0,
            svgScalerOffsetY: 0,
            svgScalerScale: 1,
        };
    },
    watch: {
        "store.singlePageMode": {
            handler: function () {
                if (store.singlePageMode) {
                    if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT) {
                        this.zoomCornerLeftTop();
                    } else {
                        this.zoomCornerRightTop();
                    }
                } else {
                    this.zoomNormal();
                }

                // window.pageControl.doChangePage();
                window.aFileControl.clearAfiles();
            },
        },
        "store.singlePageIndex": {
            handler: function () {
                if (store.singlePageMode && !store.singlePageTrigger) {
                    // this.zoomNormal();

                    if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT) {
                        if (store.singlePageIndex == 0) {
                            this.zoomCornerLeftTop();
                        } else {
                            this.zoomCornerRightTop();
                        }
                    } else {
                        if (store.singlePageIndex == 0) {
                            this.zoomCornerRightTop();
                        } else {
                            this.zoomCornerLeftTop();
                        }
                    }

                    // window.pageControl.doChangePage();
                    window.aFileControl.clearAfiles();
                }
            },
        },
        "store.nowTool": {
            handler: function () {
                this.currentPageTool = this.pageToolMap.get(store.nowTool);
            },
        },
        "afileStore.maximum": {
            handler: function (newValue) {
                if (newValue) {
                    this.pageLoader.resume();
                } else {
                    this.pageLoader.pause();
                }
            },
        },
    },
    methods: {
        //#region 滑鼠滾輪縮放
        wheelHandler: function (e) {
            if (this.isPressBookPage) return;
            this.focusWindow();

            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            let pageContainerBoundingRect = this.pageContainer.getBoundingClientRect();
            console.log("svg container rect:", svgContainerBoundingRect);
            console.log("fixedScaleMargin:", this.fixedScaleMargin);
            if (e.deltaY > 0) {
                this.containerScale -= this.scaleRatio;
                this.containerScale = Math.max(this.containerScale, store.singlePageMode ? 2 : 1);
            } else {
                this.containerScale += this.scaleRatio;
                this.containerScale = Math.min(this.containerScale, 10);
            }
            let targetPoint = {
                // x: e.clientX - this.fixedScaleMargin - (svgContainerBoundingRect.x - this.fixedScaleMargin),
                x: e.clientX - svgContainerBoundingRect.x,
                y: e.clientY - svgContainerBoundingRect.y,
            };

            console.log(`target point (${targetPoint.x}, ${targetPoint.y})`);

            this.zoom(
                targetPoint.x * windowContentScaleX.value,
                targetPoint.y * windowContentScaleY.value,
                this.containerScale,
                e.clientX - pageContainerBoundingRect.x,
                e.clientY - pageContainerBoundingRect.y
            );
        },
        //#endregion
        //#region 頁面點擊功能策略
        onPointerDown: function (e) {
            this.isPressBookPage = true;
            this.focusWindow();
            if (!this.currentPageTool) return;
            if (e.button !== 0 && e.pointerType === "mouse") return;
            this.touchPointList.push(e);
            if (e.pointerType === "touch") {
                if (store.nowTool == TOOLS.SELECTION.TOOL || store.nowTool == "touch_move" || store.nowTool == "touch_scale") {
                    store.canTouchAction = true;
                    switch (true) {
                        case this.touchPointList.length == 2:
                            store.nowTool = "touch_scale";
                            break;
                        case this.containerScale == 1:
                            store.nowTool = "touch_move";
                            break;
                    }
                }
            }
            this.currentPageTool = this.pageToolMap.get(store.nowTool);
            this.currentPageTool.onPointerDown(e);

            EventBus.getInstance()._app.setWindowPointerup(this.onPointerUp.bind(this));
        },
        onPointerMove: function (e) {
            if (!this.currentPageTool) return;
            if (e.pointerType === "touch") {
                if (store.nowTool == TOOLS.SELECTION.TOOL || store.nowTool == "touch_move" || store.nowTool == "touch_scale") {
                    if (focusStore.getSelectedObject()) {
                        store.nowTool = TOOLS.SELECTION.TOOL;
                        return;
                    }
                    switch (true) {
                        case this.touchPointList.length == 2:
                            store.nowTool = "touch_scale";
                            this.$refs.animation_container.style.left = "0px";
                            this.$refs.paintCanvas.style.left = "0px";
                            break;
                        case this.containerScale == 1:
                            store.nowTool = "touch_move";
                            break;
                    }
                }
            }
            this.currentPageTool.onPointerMove(e);
        },
        onPointerUp: function (e) {
            this.isPressBookPage = false;
            if (!this.currentPageTool) return;
            this.touchPointList = [];
            this.currentPageTool.onPointerUp(e);
        },
        //#endregion
        fitBorder: function (x, y) {
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            let pageContainerBoundingRect = this.$refs.page_container.getBoundingClientRect();

            let singlePageIndex;
            if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT) {
                singlePageIndex = 1;
            } else if (store.turnPageType == TURN_PAGE_TYPE.TURN_LEFT) {
                singlePageIndex = 0;
            }

            let limitLeft;
            let limitRight;
            let limitBottom;
            switch (settingStore.toolbarPosition) {
                case 0:
                    limitLeft =
                        store.singlePageMode && store.singlePageIndex == singlePageIndex
                            ? -svgContainerBoundingRect.width / 2 / store.currentBookPageScale.x
                            : 0;
                    limitRight =
                        store.singlePageMode && store.singlePageIndex == singlePageIndex
                            ? (pageContainerBoundingRect.width - svgContainerBoundingRect.width) / windowContentScaleX.value
                            : (pageContainerBoundingRect.width -
                                  svgContainerBoundingRect.width / (1 + Number(store.singlePageMode && store.singlePageIndex == 1 - singlePageIndex))) /
                              windowContentScaleX.value;

                    limitBottom = (pageContainerBoundingRect.height - svgContainerBoundingRect.height) / windowContentScaleY.value;

                    limitLeft = limitLeft / store.contentScale;
                    break;
                case 1:
                case 2:
                    if (store.singlePageMode) {
                        limitLeft =
                            store.singlePageIndex == singlePageIndex
                                ? ((-this.canvasWidth * (this.containerScale - 1)) / windowContentScaleX.value) *
                                  (settingStore.isFixed == 0 ? store.contentScale : store.contentScaleX)
                                : 0;
                        limitRight =
                            store.singlePageIndex == singlePageIndex
                                ? ((-this.canvasWidth * (this.containerScale - 1)) / windowContentScaleX.value) *
                                  (settingStore.isFixed == 0 ? store.contentScale : store.contentScaleX)
                                : 0;
                    } else {
                        limitLeft = 0;
                        limitRight =
                            ((-this.canvasWidth * (this.containerScale - 1)) / windowContentScaleX.value) *
                            (settingStore.isFixed == 0 ? store.contentScale : store.contentScaleX);
                    }
                    limitBottom = -this.canvasHeight * (this.containerScale - 1);
                    break;
                default:
                    break;
            }

            if (x > limitLeft) {
                x = limitLeft;
            }
            if (x < limitRight) {
                x = limitRight;
            }

            if (y > 0) {
                y = 0;
            }
            if (y <= limitBottom) {
                y = limitBottom;
            }
            console.log(y);
            return { x: Math.round(x), y: Math.round(y) };
        },
        initSvg: function () {
            console.log("init svg");
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            let pageContainerBoundingRect = this.$refs.page_container.getBoundingClientRect();
            let limitLeft = svgContainerBoundingRect.width - pageContainerBoundingRect.width - this.fixedScaleMargin;

            this.containerScale = store.singlePageMode ? 2 : 1;
            this.scale(this.containerScale);
            if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT) {
                this.move(store.singlePageMode && store.singlePageIndex == 1 ? -limitLeft : 0, 0);
            } else {
                this.move(store.singlePageMode && store.singlePageIndex == 0 ? -limitLeft : 0, 0);
            }
        },
        //#region 頁面縮放
        scaleContainer: function (scale) {
            this.pageLoader.scaleContainers(scale);
            this.pageLoader.mutiAntialiasing();
            this.scale(scale);
        },
        zoomIn: function () {
            //TODO: 確認縮放是從頁面中心 還是 顯示的畫面的中心
            this.containerScale += 0.1;
            this.containerScale = Math.min(this.containerScale, 10);
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            if (store.singlePageMode) {
                // let px = store.singlePageIndex == 0 ? 0.25 : 0.75;
                let pageContainerBoundingRect = this.$refs.page_container.getBoundingClientRect();

                // this.zoom(svgContainerBoundingRect.width * px, pageContainerBoundingRect.height * 0.5 - svgContainerBoundingRect.y, this.containerScale);
                this.zoom(
                    pageContainerBoundingRect.width * 0.5 - (svgContainerBoundingRect.x - this.fixedScaleMargin),
                    pageContainerBoundingRect.height * 0.5 - svgContainerBoundingRect.y,
                    this.containerScale
                );
            } else {
                this.zoom(
                    svgContainerBoundingRect.width * 0.5 * store.contentScale,
                    svgContainerBoundingRect.height * 0.5 * store.contentScale,
                    this.containerScale
                );
            }
        },
        zoomOut: function () {
            this.containerScale -= 0.1;
            this.containerScale = Math.max(this.containerScale, 1);
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            if (store.singlePageMode) {
                this.containerScale = Math.max(this.containerScale, 2);
                let px = store.singlePageIndex == 0 ? 0.25 : 0.75;
                let pageContainerBoundingRect = this.$refs.page_container.getBoundingClientRect();

                this.zoom(svgContainerBoundingRect.width * px, pageContainerBoundingRect.height * 0.5 - svgContainerBoundingRect.y, this.containerScale);
            } else {
                this.zoom(
                    svgContainerBoundingRect.width * 0.5 * store.contentScale,
                    svgContainerBoundingRect.height * 0.5 * store.contentScale,
                    this.containerScale
                );
            }
        },
        zoom(x, y, scale, alignX, alignY, updatePercent = true) {
            scale = Math.max(scale, 1);
            scale = Math.min(scale, 10);
            this.containerScale = scale;

            const svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            const px = x / (svgContainerBoundingRect.width * windowContentScaleX.value);
            const py = y / (svgContainerBoundingRect.height * windowContentScaleY.value);

            this.scaleContainer(this.containerScale);
            let newSvgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            let pageContainerBoundingRect = this.$refs.animation_container.getBoundingClientRect();

            let newLeft, newTop;
            if (alignX && alignY) {
                console.log(`align ${alignX} , ${alignY}`);
                newLeft = (alignX - newSvgContainerBoundingRect.width * px) / store.currentBookPageScale.x / windowContentScaleX.value / store.bookPageScale.x;
                newTop = (alignY - newSvgContainerBoundingRect.height * py) / store.currentBookPageScale.y / windowContentScaleY.value / store.bookPageScale.y;
            } else {
                newLeft =
                    (pageContainerBoundingRect.width * 0.5 - newSvgContainerBoundingRect.width * px) / store.currentBookPageScale.x / windowContentScaleX.value;
                newTop =
                    (pageContainerBoundingRect.height * 0.5 - newSvgContainerBoundingRect.height * py) /
                    store.currentBookPageScale.y /
                    windowContentScaleY.value;
                console.log(`new page percent point: ${this.pagePercentPoint.x} ${this.pagePercentPoint.y}`);
            }

            let fixedPoint = this.fitBorder(newLeft, newTop);

            this.move(fixedPoint.x, fixedPoint.y);

            if (updatePercent) {
                let newPx =
                    (pageContainerBoundingRect.width * 0.5 - fixedPoint.x * windowContentScaleX.value * store.currentBookPageScale.x) /
                    newSvgContainerBoundingRect.width;
                let newPy =
                    (pageContainerBoundingRect.height * 0.5 - fixedPoint.y * windowContentScaleY.value * store.currentBookPageScale.y) /
                    newSvgContainerBoundingRect.height;
                this.pagePercentPoint.x = newPx;
                this.pagePercentPoint.y = newPy;
            }

            this.containerPosition.x = fixedPoint.x;
            this.containerPosition.y = fixedPoint.y;

            this.pageLoader.setStagePosition(fixedPoint);
            this.scalePaintAndMove(this.containerScale, fixedPoint.x, fixedPoint.y);
        },
        move(x, y) {
            if (x != null && x != undefined) {
                this.svgScaler.style.left = x + "px";
                this.svgTextScaler.style.left = x + "px";
            }
            if (y != null && y != undefined) {
                this.svgScaler.style.top = y + "px";
                this.svgTextScaler.style.top = y + "px";
            }

            this.svgScalerOffsetX = x;
            this.svgScalerOffsetY = y;
            this.pageLoader.loadPageByView(this.svgScalerOffsetX, this.svgScalerOffsetY, this.svgScalerScale);
        },
        scale(scale) {
            this.svgScaler.style.transform = `scale(${scale})`;
            this.svgTextScaler.style.transform = `scale(${scale})`;

            this.svgScalerScale = scale;
            this.pageLoader.loadPageByView(this.svgScalerOffsetX, this.svgScalerOffsetY, this.svgScalerScale);
        },
        //#endregion
        init() {
            const self = this;
            this.pageLoader = new PageLoader();
            window.loader = this.pageLoader;
            window.pageControl = new PageControl(this.pageLoader);
            window.pageControl.onFinishGoPage = function () {
                //self.initSvg();
            };
            this.pageItemControl = new PageItemCreator(this.pageLoader);
            window.currentPageItemControl = this.pageItemControl;

            focusStore.mainBookPageItemControl = this.pageItemControl;
            focusStore.setMainPageItemControl(this.pageItemControl);
            focusStore.setNowPageItemControl(this.pageItemControl, "mainPage");

            this.pageLoader.initFinishCallback = function () {
                self.pageLoader.loadNewPage(window.pageControl.getNowPages);
            };

            this.pageLoader.pageStageInitCallback = function () {
                // const clientWidth = self.$refs.animation_container.clientWidth
                // self.pageContainer.style.left = (window.pageWidth - clientWidth) / 2 + "px";
                // self.svgScaler.style.left = (window.pageWidth - clientWidth) / 2 + "px"
                // self.fixedScaleMargin = (window.pageWidth - clientWidth) / 2;

                // self.canvasWidth = self.$refs.animation_container.clientWidth;
                // self.canvasHeight = self.$refs.animation_container.clientHeight;
                self.centerPage();
                // console.log(PainterProxy.getInstance());
                setTimeout(() => {
                    PainterProxy.getInstance().setPainter("paint-canvas", true, true);
                    self.focusWindow();
                    focusStore.setMainBookPage(self);
                }, 1000);

                self.pageLoader.scaleContainers(1);
            };
            this.pageLoader.renderBook = function () {
                self.triggerLoading();
            };

            window.pageControl.firstRenderComplete = function () {
                // console.log("first render complete");
                // if (store.singlePageMode) {
                //     if (store.singlePageIndex == 0) {
                //         self.zoomCornerLeftTop();
                //     } else {
                //         self.zoomCornerRightTop();
                //     }
                //     store.switchSinglePageTrigger(false);
                // }
            };

            this.containerSize.width = window.innerWidth * this.containerScale;
            this.containerSize.height = window.innerHeight * this.containerScale;

            this.pageContainer = this.$refs.animation_container;
            this.svgContainer = this.$refs.svg_container;
            this.svgTextContainer = this.$refs.svg_text_container;
            this.svgScaler = this.$refs.svg_scaler;
            this.svgTextScaler = this.$refs.svg_text_scaler;
            this.bookContainer = this.$refs.bookContainer;

            this.pageLoader.onStageResize = function (xScale, scale) {
                // console.log('scale!!')
                self.svgContainer.style.transform = `scale(${scale})`;
                self.svgTextContainer.style.transform = `scale(${scale})`;
                // if (settingStore.isFixed == 0) {
                // } else {
                //     self.svgContainer.style.transform = `scale(${xScale}, ${scale})`;
                // }

                self.centerPage();
            };

            this.pageToolMap.set(TOOLS.SELECTION.TOOL, new PageMove(this));
            this.pageToolMap.set(TOOLS.ZOOM_PART.TOOL, new ZoomPart(this));
            this.pageToolMap.set("touch_move", new TouchMove(this));
            this.pageToolMap.set("touch_scale", new TouchScale(this, "BookPage"));
            this.currentPageTool = this.pageToolMap.get(store.nowTool);
        },
        //#region 縮放功能
        zoomCornerRightTop() {
            this.containerScale = 2;
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            this.zoom(
                svgContainerBoundingRect.width * 0.75 * windowContentScaleX.value,
                svgContainerBoundingRect.height * 0.25 * windowContentScaleY.value,
                this.containerScale
            );
        },
        zoomCornerLeftTop() {
            this.containerScale = 2;
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            this.zoom(
                svgContainerBoundingRect.width * 0.25 * windowContentScaleX.value,
                svgContainerBoundingRect.height * 0.25 * windowContentScaleY.value,
                this.containerScale
            );
        },
        zoomCornerRightBottom() {
            this.containerScale = 2;
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            this.zoom(
                svgContainerBoundingRect.width * 0.75 * windowContentScaleX.value,
                svgContainerBoundingRect.height * 0.75 * windowContentScaleY.value,
                this.containerScale
            );
        },
        zoomCornerLeftBottom() {
            this.containerScale = 2;
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            this.zoom(
                svgContainerBoundingRect.width * 0.25 * windowContentScaleX.value,
                svgContainerBoundingRect.height * 0.75 * windowContentScaleY.value,
                this.containerScale
            );
        },
        zoomNormal() {
            this.containerScale = store.singlePageMode ? 2 : 1;
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            if (store.singlePageMode) {
                this.containerScale = Math.max(this.containerScale, 2);
                let px;
                if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT) {
                    px = store.singlePageIndex == 0 ? 0.25 : 0.75;
                } else {
                    px = store.singlePageIndex == 1 ? 0.25 : 0.75;
                }
                console.log("px:", px);
                let pageContainerBoundingRect = this.$refs.page_container.getBoundingClientRect();

                this.zoom(
                    svgContainerBoundingRect.width * px * store.contentScale,
                    ((pageContainerBoundingRect.height * 0.5) / store.contentScale - svgContainerBoundingRect.y) * store.contentScale,
                    this.containerScale
                );
            } else {
                this.zoom(
                    svgContainerBoundingRect.width * 0.5 * store.contentScale,
                    svgContainerBoundingRect.height * 0.5 * store.contentScale,
                    this.containerScale
                );
            }
        },
        //#endregion
        triggerLoading() {
            const self = this;
            // self.loadingOpacity = 0;
            // clearInterval(self.interval);

            // let addRate = 0.5;
            // console.countReset("add rate");
            // this.interval = setInterval(() => {
            //     self.loadingOpacity += addRate;
            //     // if(addRate < 0.8) {
            //     //     addRate += 0.005;
            //     // }
            //     console.count("add rate");

            //     if (self.loadingOpacity >= 2) {
            //         self.loadingOpacity = 2;
            //         clearInterval(self.interval);
            //         self.interval = null;
            //     }
            // }, 500);
            this.svgShow = true;
            this.pageContainerShow = true;
            setTimeout(() => {
                self.zoomNormal();
            });
            store.switchSinglePageTrigger(false);
        },
        clearLoadingAnim() {
            this.svgShow = false;
            this.pageContainerShow = false;
            clearTimeout(this.pageItemControl.initTimer);
            clearTimeout(this.pageItemControl.timer);
            clearInterval(this.interval);
            this.loadingOpacity = 0;
        },
        centerPage() {
            const self = this;
            if (self.$refs.animation_container == null || self.bookContainer == null) return;
            const clientWidth = self.$refs.animation_container.clientWidth || 0;

            switch (settingStore.isFixed) {
                case 0:
                    self.bookContainer.style.left = (settingStore.toolbarPosition == 1 ? store.toolbarWidth : 0) + "px";
                    self.fixedScaleMargin = (window.pageWidth - clientWidth) / 2 + store.pageLeft;
                    self.fixedScaleMarginRight = (window.pageWidth - clientWidth) / 2 + store.pageRight;
                    break;
                case 1:
                    self.bookContainer.style.left = (settingStore.toolbarPosition == 1 ? store.toolbarWidth : 0) + "px";
                    self.fixedScaleMargin = 0;
                    self.fixedScaleMarginRight = (window.pageWidth - clientWidth) / 2 + store.pageRight;
                    break;
            }
            self.canvasWidth = self.$refs.animation_container.clientWidth;
            self.canvasHeight = self.$refs.animation_container.clientHeight;

            store.setGlobalPaintData({
                width: self.$refs.animation_container.clientWidth,
                height: self.$refs.animation_container.clientHeight,
                margin: self.fixedScaleMargin,
            });
        },
        /**
         * 縮放畫布並且移動畫布 set transform with matrix
         * @param {number} scale scale painter canvas
         * @param {number} x translate x distance
         * @param {number} y translate y distance
         */
        scalePaintAndMove(scale, x, y) {
            PainterProxy.getInstance().updateViewportTransform(x, y, scale);
        },
        focusWindow() {
            PainterProxy.getInstance().setCurrentPainter("paint-canvas");
            setTimeout(() => {
                focusStore.setNowPageItemControl(this.pageItemControl, "mainPage");
                focusStore.setFocusBookPage(this);
            });
        },
        handleDeleteZone(e) {
            console.log("drop on delete zone");
        },
        backPosition() {
            if (this.svgContainer) {
                let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
                const x = svgContainerBoundingRect.width * store.contentScale * this.pagePercentPoint.x || svgContainerBoundingRect.width * 0.5;
                const y = svgContainerBoundingRect.height * store.contentScale * this.pagePercentPoint.y || svgContainerBoundingRect.height * 0.5;

                // console.log(`(${x}, ${y})`);
                this.zoom(x, y, this.containerScale, null, null, false);
            }
        },
    },
    mounted: function () {
        EventBus.getInstance().setBookPage(this);
    },
    computed: {
        fixedClipPath() {
            if (settingStore.isFixed == 0) {
                return `clip-path:inset(0px ${this.fixedScaleMarginRight}px 0px 0px)`;
            } else {
                return `clip-path:inset(0px)`;
            }
        },
        svgOpacity: function () {
            return { "page-enter-active": this.svgShow, "page-leave-active": !this.svgShow };
        },
        pageOpacity: function () {
            return { "pageItem_and_painter_container-enter-active": this.pageContainerShow, "page-leave-active": !this.pageContainerShow };
        },
        pageWidth() {
            return window.innerWidth - store.toolbarWidth;
        },
        pageHeight() {
            return store.baseSize.height - store.toolbarHeight;
        },
        bookContainerStyle() {
            this.centerPage();

            switch (settingStore.isFixed) {
                case 0:
                    // store.currentBookPageScale = { x: Math.min(1, store.bookPageScale.y), y: Math.min(1, store.bookPageScale.y) };
                    store.currentBookPageScale = { x: 1, y: 1 };
                    return {
                        width: store.baseSize.width - this.fixedScaleMarginRight + "px",
                        height: this.pageHeight + "px",
                        transform: "scale(" + store.bookPageScale.x + "," + store.bookPageScale.y + ")",
                        visibility: bookPageStore.isHidden == true ? "hidden" : "visible",
                    };
                case 1:
                    store.currentBookPageScale = { x: 1, y: 1 };
                    return {
                        width: store.baseSize.width - this.fixedScaleMarginRight + "px",
                        height: this.pageHeight + "px",
                        transform: "scale(" + store.bookPageScale.x + "," + store.bookPageScale.y + ")",
                        visibility: bookPageStore.isHidden == true ? "hidden" : "visible",
                    };
            }
        },
        containerWidth() {
            return this.$refs.page_container.getBoundingClientRect().width;
        },
        zoomPartZoneLeft() {
            return this.zoomLeft + this.fixedScaleMargin;
        },
        toolStyle() {
            return {
                left: this.containerPosition.x + "px",
                top: this.containerPosition.y + "px",
                transform: "scale(" + this.containerScale + ")",
            };
        },
    },
    components: {
        Ruler,
        OnlyReadButtons,
    },
};
</script>

<style scoped>
#book-container {
    position: absolute;
    transform-origin: left top;
    overflow: hidden;
}

#left-page-loading {
    position: absolute;
    background-size: contain;
    width: 1844px;
    height: 2369px;
    z-index: -1;
    left: 0px;
}

#right-page-loading {
    position: absolute;
    background-size: contain;
    width: 1844px;
    height: 2369px;
    z-index: -1;
    left: 1843px;
}

.page {
    width: fit-content;
    height: fit-content;
}

#page-container {
    position: absolute;
    display: flex;
    justify-content: center;
    top: 0px;
    z-index: var(--z-index-page-container);
}

#svg-container,
#svg-text-container {
    position: absolute;
    transform-origin: top left;
    display: flex;
    justify-content: flex-start;
    z-index: 1;
}

#svg-scaler,
#svg-text-scaler {
    position: absolute;
    transform-origin: top left;
}

.page-svg {
    transform-origin: top left;
    width: 1844px;
    height: 2369px;
}

#svg-clip-path {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: var(--z-index-svg-clip-path);
}

#right-page-svg {
    margin-left: -1px;
    left: 1844px;
    position: fixed;
    z-index: -1;
}

#left-page-svg {
    margin-right: -1px;
    width: 3688px;
}

#right-page-svg-text {
    margin-left: -1px;
    left: 1844px;
    position: absolute;
    z-index: -1;
}

#left-page-svg-text {
    position: absolute;
    margin-right: -1px;
    width: 3688px;
}

.zoom-part-zone {
    position: absolute;
    background-color: rgba(0, 255, 255, 0.33);
    pointer-events: none;
    z-index: 999;
}

.mask {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 90%;
    z-index: 2999;
    background-color: rgba(0, 0, 0, 0.7);
}

.deleteZone {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 90%;
    z-index: 2999;
    background-color: rgba(0, 0, 0, 0);
}

.loading-mask {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    z-index: var(--z-index-loading-mask);
}

.center {
    position: absolute;
    right: 0px;
    left: 0px;
    top: 0px;
    bottom: 0px;
    margin: auto;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.special-container {
    position: absolute;
    display: flex;
    flex-direction: row;
    width: 3688px;
    height: 2369px;
}

.pageItem_and_painter_container-enter-active {
    transition: opacity 0.1s ease;
}

.page-enter-active {
    transition-delay: 0.2s;
    transition: opacity 1s ease;
}

.page-leave-active {
    opacity: 0;
}

.tools {
    position: absolute;
    z-index: var(--z-index-tools);
}
</style>

<style>
#full-png-page {
    position: absolute;
}

#full-png-page > img {
    position: absolute;
    left: 0px;
    top: 0px;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>
